// removed by extract-text-webpack-plugin
module.exports = {"Layout":"_3XKyj8WgQ9s0ebWd1kQ9tk","Description":"_1toYIzgteb24dBQXVD-kK8","Title":"_3Lc__9kkC3pQ3mogZQnDEw","scores":"_1uiKmFqbxZFBZWWpuZB9Gk"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Layout/Layout.scss
 ** module id = 391
 ** module chunks = 1
 **/